<template>
  <div class="currency_rules white_back">
    <CommonHeader class="header">
      {{ $t("currency.rule") }}
    </CommonHeader>
    <div>
      <section>
        <div class="currency_title">
          <!-- {{ titles[key] }} -->
          1、金豆获取细则
        </div>
        <div class="add_dec_table">
          <div class="flex-box title">
            <div class="alias br bb">{{ $t('currency_rules.user_action') }}</div>
            <div class="desc br bb">{{ $t('currency_rules.from') }}</div>
            <div class="score br bb">
              {{ key === "add" ? $t('currency_rules.accumulation') : $t('currency_rules.reduction') }}
            </div>
          </div>
          <div
            v-for="(item, index) in settings"
            :key="item.id"
            class="flex-box"
            :class="{ active: !!(index % 2) }"
          >
            <div class="alias br bb">{{ item.alias }}</div>
            <div class="desc br bb">{{ item.desc }}</div>
            <div class="score br bb" :class="{redscore:item.score<0}">{{ key === 'add'?'+':'' }}{{ item.score }}</div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
  import * as currencyApi from '@/api/currency'
  export default {
    data () {
      return {
        levels: [],
        settings: [],
      }
    },
    async mounted () {
      const { data } = await currencyApi.getCurrencyLevels()
      // this.levels = data
      // const { data: setting } = await currencyApi.getCurrencySetting()
      // console.log(data)
      this.settings = data
    },
  }
</script>

<style lang="less" scoped>
.currency_title {
  margin: 20px 30px;
  font-size: 30px;
}
.other {
  margin: 30px;
  color:#808080
}
.title {
  div {
    color: #fff !important;
  }
  background-color: #adb1ba;
}
.add_dec_table {
  margin: 10px 30px;
  border: 1px solid #e5e5e5;
  .br {
    border-right: 1px solid #e5e5e5;
  }
  .bb {
    border-bottom: 1px solid #e5e5e5;
  }
  .flex-box {
    color: #808080;
    text-align: center;
    display: flex;
    > div {
      padding: 30px 10px;
      align-items: center;
    }
  }
  .alias {
    width: 30%;
  }
  .desc {
    width: 40%;
  }
  .score {
    color: #24962C;
    width: 30%;
    &.redscore {
      color: #D52B1E;
    }
  }
  .detail {
    width: 0;
  }
}
.active {
  background-color: #e5e5e5;
}
.currency_rules {
  font-size: 24px;
  min-height: 100vh;
  .currency_rules_table {
    margin: 30px;
    border: 1px solid #e5e5e5;
    .flex-box.title {
      height: 90px;
      line-height: 90px;
      color: #fff;
      div {
        background-color: #adb1ba;
      }
    }
    .flex-box {
      height: 100px;
      line-height: 100px;
      color: #808080;
      .level {
        width: 33.66%;
        border-bottom: 1px solid #e5e5e5;
        border-right: 1px solid #e5e5e5;
      }
      .name {
        width: 66%;
        border-bottom: 1px solid #e5e5e5;
        border-right: 1px solid #e5e5e5;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .level-img {
        width: 30px;
      }
      .start_end {
        width: 66.66%;
        border-bottom: 1px solid #e5e5e5;
      }
      div {
        text-align: center;
      }
    }
  }
}
</style>
